import { SetLeftRightIcon } from './SetLeftRightIcon';

/**
 * author: Simran
 * id E1BE2EC4-D5D5-475C-A562-9855DA1612FB
 * name set-left-right
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/set-left-right.svg
 * tags
 * - Database 
 */
export const ExclusionIcon = SetLeftRightIcon;
export default ExclusionIcon